// // WORKING OLD
// import React, { useEffect, useState, useRef } from 'react';
// import { useParams } from 'react-router-dom';
// import {
//   fetchBusinessById,
//   API_URL,
// } from '../services/api';
// import './BusinessDetail.css';
// import verdureverified from './verdureverified.png';

// const BusinessDetail = () => {
//   const { businessId } = useParams();
//   const [products, setProducts] = useState([]);
//   const [businessInfo, setBusinessInfo] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [productLoading, setProductLoading] = useState(false);
//   const [sustainabilityInfo, setSustainabilityInfo] = useState([]);
//   const [sustainabilityLoading, setSustainabilityLoading] = useState(false);
//   const [showVerifiedInfo, setShowVerifiedInfo] = useState(false);

//   // Refs for scroll functionality
//   const productsRef = useRef(null);
//   const aboutRef = useRef(null);
//   const contactRef = useRef(null);
//   const sustainabilityRef = useRef(null);

//   useEffect(() => {
//     // First fetch business details
//     const fetchBusinessDetails = async () => {
//       try {
//         const businessData = await fetchBusinessById(businessId);
//         setBusinessInfo(businessData);
//         // Once business info is loaded, we can start loading products
//         fetchProducts(1);
//         // Also fetch sustainability info
//         fetchSustainabilityInfo();
//       } catch (err) {
//         console.error('Error fetching business details:', err);
//         setError('Failed to load business details.');
//         setLoading(false);
//       }
//     };

//     fetchBusinessDetails();
//   }, [businessId]);

//   // Function to fetch sustainability information
//   const fetchSustainabilityInfo = async () => {
//     setSustainabilityLoading(true);
//     try {
//       const response = await fetch(`${API_URL}api/verduresustainability/${businessId}/`);
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data = await response.json();
//       setSustainabilityInfo(data || []);
//       setSustainabilityLoading(false);
//     } catch (err) {
//       console.error('Error fetching sustainability info:', err);
//       // We don't set main error for this as it's not critical
//       setSustainabilityInfo([]);
//       setSustainabilityLoading(false);
//     }
//   };

//   // Function to fetch products with pagination
//   const fetchProducts = async (page) => {
//     setProductLoading(true);
//     try {
//       // Direct fetch from API with pagination
//       const response = await fetch(`${API_URL}api/products-by-business/${businessId}/?page=${page}`);
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data = await response.json();

//       // Update products state with the lightweight data
//       setProducts(data.results || []);

//       // Calculate total pages
//       const count = data.count || 0;
//       const pageSize = 10; // Match with backend page_size
//       setTotalPages(Math.ceil(count / pageSize));

//       setCurrentPage(page);
//       setProductLoading(false);

//       if (loading) {
//         setLoading(false);
//       }
//     } catch (err) {
//       console.error('Error fetching products:', err);
//       setError('Failed to load products.');
//       setProductLoading(false);

//       if (loading) {
//         setLoading(false);
//       }
//     }
//   };

//   // Change page handler
//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= totalPages) {
//       setCurrentPage(newPage);
//       fetchProducts(newPage);

//       // Scroll to top of products section when changing pages
//       productsRef.current?.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   // Scroll functions for navigation
//   const scrollToProducts = () => {
//     productsRef.current?.scrollIntoView({ behavior: 'smooth' });
//   };

//   const scrollToAbout = () => {
//     aboutRef.current?.scrollIntoView({ behavior: 'smooth' });
//   };

//   const scrollToContact = () => {
//     contactRef.current?.scrollIntoView({ behavior: 'smooth' });
//   };

//   const scrollToSustainability = () => {
//     sustainabilityRef.current?.scrollIntoView({ behavior: 'smooth' });
//   };

//   const generatePaginationNumbers = () => {
//     let pages = [];
//     const maxPagesToShow = 5; // Maximum page numbers to display

//     if (totalPages <= maxPagesToShow) {
//       // Show all pages if total pages is less than or equal to maxPagesToShow
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(i);
//       }
//     } else {
//       // Always include first page
//       pages.push(1);

//       if (currentPage <= 3) {
//         // If current page is near the beginning
//         pages.push(2, 3, 4);
//         pages.push('...');
//         pages.push(totalPages);
//       } else if (currentPage >= totalPages - 2) {
//         // If current page is near the end
//         pages.push('...');
//         pages.push(totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
//       } else {
//         // If current page is in the middle
//         pages.push('...');
//         pages.push(currentPage - 1, currentPage, currentPage + 1);
//         pages.push('...');
//         pages.push(totalPages);
//       }
//     }

//     return pages;
//   };

//   if (error) {
//     return <div className="error-container">{error}</div>;
//   }

//   const hasSustainabilityInfo = sustainabilityInfo && sustainabilityInfo.length > 0;

//   return (
//     <div className="business-detail-container">
//       {/* Loading Overlay */}
//       {loading && (
//         <div className="loading-overlay">
//           <div className="spinner"></div>
//         </div>
//       )}

//       {/* Navigation bar */}
//       <nav className="shop-navigation">
//         <div className="shop-nav-container">
//           <div className="shop-name">{businessInfo?.name}</div>
//           <div className="shop-nav-links">
//             <button onClick={scrollToAbout} className="nav-link">About</button>
//             {hasSustainabilityInfo && (
//               <button onClick={scrollToSustainability} className="nav-link">Sustainability</button>
//             )}
//             <button onClick={scrollToProducts} className="nav-link">Products</button>
//             <button onClick={scrollToContact} className="nav-link">Contact</button>
//           </div>
//         </div>
//       </nav>

//       {/* Banner and Logo Section */}
//       <div className={`shop-banner-container ${!businessInfo?.banner ? 'no-banner' : ''}`}>
//         {businessInfo?.banner ? (
//           <div className="banner-wrapper">
//             <img
//               src={businessInfo.banner}
//               alt={`${businessInfo.name} banner`}
//               className="shop-banner"
//             />
//           </div>
//         ) : (
//           // Fallback placeholder div when there's no banner
//           <div className="banner-placeholder"></div>
//         )}

//         {businessInfo?.logonew && (
//           <div className="logo-container">
//             <div className="logo-wrapper">
//               <img
//                 src={businessInfo.logonew}
//                 alt={`${businessInfo.name} logo`}
//                 className="shop-logo"
//               />
//             </div>
//           </div>
//         )}

//         {/* Verdure Verified Badge */}

// {businessInfo?.verdure_verified && (
//   <div className="verified-badge-container">
//     <div className="verified-badge-wrapper">
//       <img
//         src={verdureverified}
//         alt="Verdure Verified"
//         className="verified-badge"
//       />
//       <button
//         className="info-button"
//         onClick={() => setShowVerifiedInfo(!showVerifiedInfo)}
//         aria-label="Show Verdure Verified information"
//       >
//         i
//       </button>
//       {showVerifiedInfo && (
//         <div className="verified-info-tooltip">
//           <p>Verdure Verified means our team checked through this business and we did research on them, and the business also sent additional information for us to help verify what they provided. In many cases we also provide notes below.</p>
//         </div>
//       )}
//     </div>
//   </div>
// )}
//       </div>

//       {/* Shop Title */}
//       <div className="shop-intro">
//         <h1 className="shop-title">{businessInfo?.name}</h1>
//       </div>

//       {/* About and Sustainability Sections - Two Column Layout on Desktop */}
//       <div className="about-sustainability-container">
//         {/* About Business Section */}
//         <div ref={aboutRef} className="about-section">
//           <h2 className="section-title">About {businessInfo?.name}</h2>
//           <div className="about-content">
//             <div className="about-full-width">
//               <div className="about-description">
//                 <h3>About</h3>
//                 <p>{businessInfo?.description}</p>

//                 <div className="business-details-grid">
//                   <div className="detail-item">
//                     <h4>Shipping</h4>
//                     <p>{businessInfo?.shipping_strategy}</p>
//                   </div>

//                   <div className="detail-item">
//                     <h4>Price Range</h4>
//                     <p>{businessInfo?.price_range}</p>
//                   </div>

//                   <div className="detail-item">
//                     <h4>Production</h4>
//                     <p>{businessInfo?.production}</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Sustainability Section - Only shown if there's data */}
//         {hasSustainabilityInfo && (
//           <div ref={sustainabilityRef} className="sustainability-section">
//             <h2 className="section-title">Verdure Notes</h2>
//             <div className="sustainability-content">
//               {sustainabilityLoading ? (
//                 <div className="sustainability-loading">
//                   <div className="spinner sustainability-spinner"></div>
//                 </div>
//               ) : (
//                 <div className="sustainability-items">
//                   {sustainabilityInfo.map((item) => (
//                     <div key={item.id} className="sustainability-item">
//                       <h3>{item.title}</h3>
//                       <p>{item.explanation}</p>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Products Section */}
//       <div ref={productsRef} className="products-section">
//         <h2 className="section-title">Products by {businessInfo?.name}</h2>

//         {productLoading ? (
//           <div className="product-loading">
//             <div className="spinner product-spinner"></div>
//           </div>
//         ) : products.length > 0 ? (
//           <>
//             <div className="products-grid">
//               {products.map((product) => (
//                 <div key={product.id} className="product-card">
//                   <a href={`/shop/products/${product.id}`} className="product-link">
//                     <div className="product-image-container">
//                       <img
//                         src={product.primary_image || '/placeholder.jpg'}
//                         alt={product.name}
//                         className="product-image"
//                       />
//                     </div>
//                     <div className="product-info">
//                       <h3 className="product-name">{product.name}</h3>
//                       <p className="product-price">${Number(product.price || 0).toFixed(2)}</p>
//                     </div>
//                   </a>
//                 </div>
//               ))}
//             </div>

//             {/* Pagination Controls */}
//             {/* {totalPages > 1 && (
//               <div className="pagination-controls">
//                 <button
//                   onClick={() => handlePageChange(currentPage - 1)}
//                   disabled={currentPage === 1}
//                   className="pagination-button"
//                 >
//                   Previous
//                 </button>

//                 <div className="pagination-info">
//                   Page {currentPage} of {totalPages}
//                 </div>

//                 <button
//                   onClick={() => handlePageChange(currentPage + 1)}
//                   disabled={currentPage === totalPages}
//                   className="pagination-button"
//                 >
//                   Next
//                 </button>
//               </div>
//             )} */}

// {totalPages > 1 && (
//   <div className="pagination-controls">
//     <button
//       onClick={() => handlePageChange(currentPage - 1)}
//       disabled={currentPage === 1}
//       className="pagination-button"
//     >
//       Previous
//     </button>

//     <div className="pagination-numbers">
//       {/* Generate page number buttons */}
//       {generatePaginationNumbers().map((pageNum) => (
//         pageNum === '...' ? (
//           <span key={`ellipsis-${Math.random()}`} className="pagination-ellipsis">...</span>
//         ) : (
//           <button
//             key={pageNum}
//             onClick={() => handlePageChange(pageNum)}
//             className={`page-number ${currentPage === pageNum ? 'active' : ''}`}
//           >
//             {pageNum}
//           </button>
//         )
//       ))}
//     </div>

//     <button
//       onClick={() => handlePageChange(currentPage + 1)}
//       disabled={currentPage === totalPages}
//       className="pagination-button"
//     >
//       Next
//     </button>
//   </div>
// )}
//           </>
//         ) : (
//           <div className="no-products-message">
//             No products available from this business at the moment.
//           </div>
//         )}
//       </div>

//       {/* Contact Section */}
//       <div ref={contactRef} className="contact-section">
//         <h2 className="section-title">Contact {businessInfo?.name}</h2>
//         <div className="contact-info">
//           <p><strong>Email:</strong> {businessInfo?.email}</p>
//           {businessInfo?.website && (
//             <p>
//               <strong>Website:</strong>{' '}
//               <a
//                 href={businessInfo.website}
//                 className="website-link"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 {businessInfo.website}
//               </a>
//             </p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default BusinessDetail;

// Old css style
// /* Added styles for sustainability section */
// .about-sustainability-container {
//   display: flex;
//   flex-wrap: wrap;
//   gap: 30px;
//   padding: 0 20px;
// }

// .about-section {
//   flex: 1;
//   min-width: 300px;
//   padding: 0 0 40px 0;
// }

// .sustainability-section {
//   flex: 1;
//   min-width: 300px;
//   padding: 0 0 40px 0;
// }

// .sustainability-content {
//   background-color: #f9f9f9;
//   padding: 20px;
//   border-radius: 8px;
// }

// .sustainability-items {
//   display: flex;
//   flex-direction: column;
//   gap: 20px;
// }

// .sustainability-item {
//   border-bottom: 1px solid #e1e3df;
//   padding-bottom: 15px;
// }

// .sustainability-item:last-child {
//   border-bottom: none;
//   padding-bottom: 0;
// }

// .sustainability-item h3 {
//   font-size: 18px;
//   font-weight: 600;
//   margin-bottom: 10px;
//   color: #4CAF50;
// }

// .sustainability-item p {
//   font-size: 15px;
//   line-height: 1.6;
//   color: #333;
//   margin-bottom: 0;
// }

// .sustainability-loading {
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   min-height: 100px;
// }

// .sustainability-spinner {
//   width: 40px;
//   height: 40px;
//   border-width: 3px;
// }

// /* Mobile Responsiveness */
// @media (max-width: 768px) {
//   .about-content {
//     grid-template-columns: 1fr;
//   }

//   .logo-container {
//     left: 50%;
//     transform: translateX(-50%);
//   }

//   .products-grid {
//     grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
//   }

//   /* Stack sustainability section below about on mobile */
//   .about-section, .sustainability-section {
//     flex-basis: 100%;
//   }
// }

// .business-detail-container {
//   max-width: 1200px;
//   margin: 0 auto;
//   font-family: 'Graphik Webfont', -apple-system, 'Helvetica Neue', sans-serif;
//   color: #222;
//   position: relative;
// }

// /* Loading Overlay Styles */
// .loading-overlay {
//   position: fixed;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background-color: rgba(255, 255, 255, 0.8);
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   z-index: 9999;
// }

// .spinner {
//   width: 60px;
//   height: 60px;
//   border: 5px solid rgba(0, 128, 0, 0.1);
//   border-radius: 50%;
//   border-top-color: #008000;
//   animation: spin 1s ease-in-out infinite;
// }

// @keyframes spin {
//   to {
//     transform: rotate(360deg);
//   }
// }

// /* Navigation Styles */
// .shop-navigation {
//   position: sticky;
//   top: 0;
//   background-color: white;
//   padding: 12px 0;
//   border-bottom: 1px solid #e1e3df;
//   z-index: 100;
// }

// .shop-nav-container {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   max-width: 1200px;
//   margin: 0 auto;
//   padding: 0 20px;
// }

// .shop-name {
//   font-weight: 600;
//   font-size: 18px;
// }

// .shop-nav-links {
//   display: flex;
//   gap: 20px;
// }

// .nav-link {
//   background: none;
//   border: none;
//   color: #222;
//   font-size: 16px;
//   cursor: pointer;
//   padding: 6px 12px;
//   border-radius: 24px;
//   transition: background-color 0.2s;
// }

// .nav-link:hover {
//   background-color: #f5f5f5;
// }

// /* Banner and Logo Styles */
// .shop-banner-container {
//   position: relative;
//   margin-bottom: 60px;
// }

// .banner-wrapper {
//   width: 100%;
//   height: 300px;
//   overflow: hidden;
// }

// .shop-banner {
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
//   object-position: center;
// }

// .logo-container {
//   position: absolute;
//   left: 30px;
//   bottom: -40px;
// }

// .logo-wrapper {
//   width: 120px;
//   height: 120px;
//   border-radius: 8px;
//   background-color: white;
//   box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
//   padding: 6px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }

// .shop-logo {
//   max-width: 100%;
//   max-height: 100%;
//   border-radius: 4px;
//   object-fit: contain;
// }

// /* Shop Intro Styles */
// .shop-intro {
//   text-align: center;
//   margin-bottom: 40px;
//   padding: 0 20px;
// }

// .shop-title {
//   font-size: 28px;
//   font-weight: 600;
//   margin: 0 0 10px;
// }

// .shop-tagline {
//   font-size: 16px;
//   color: #595959;
//   margin: 0;
// }

// /* Products Section */
// .products-section {
//   margin-bottom: 60px;
//   padding: 0 20px;
// }

// .section-title {
//   font-size: 24px;
//   font-weight: 500;
//   margin-bottom: 30px;
//   border-bottom: 1px solid #e1e3df;
//   padding-bottom: 15px;
// }

// .products-grid {
//   display: grid;
//   grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
//   gap: 24px;
// }

// /* .product-card {
//   border-radius: 4px;
//   overflow: hidden;
//   transition: transform 0.3s;
// } */

// .product-card {
//   border-radius: 4px;
//   overflow: hidden;
//   transition: transform 0.3s;
//   display: flex;
//   flex-direction: column;
//   height: 100%;
//   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
//   background-color: white;
// }

// .product-card:hover {
//   transform: translateY(-5px);
//   box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
// }

// .product-link {
//   /* text-decoration: none;
//   color: inherit; */
//   text-decoration: none;
//   color: inherit;
//   display: flex;
//   flex-direction: column;
//   height: 100%;
// }

// .product-image-container {
//   aspect-ratio: 1 / 1;
//   overflow: hidden;
// }

// .product-image {
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
//   transition: transform 0.5s;
// }

// .product-card:hover .product-image {
//   transform: scale(1.05);
// }

// .product-info {
//   padding: 12px 8px;
//   flex-grow: 1;
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
//   min-height: 70px;
// }

// .product-name {
//   font-size: 14px;
//   font-weight: 500;
//   margin: 0 0 8px;
//   color: #222;

//   /* Cross-browser line clamp configuration */
//   display: -webkit-box;
//   display: box;
//   -webkit-line-clamp: 2;
//   line-clamp: 2;
//   -webkit-box-orient: vertical;
//   box-orient: vertical;
//   overflow: hidden;
//   line-height: 1.4;
// }

// .product-price {
//   /* font-weight: 600;
//   margin: 0;
//   font-size: 16px; */
//   font-weight: 600;
//   margin: 0;
//   font-size: 16px;
//   color: #4CAF50;
// }

// /* About Section */
// .about-content {
//   width: 100%;
//   display: block;
// }

// .about-full-width {
//   max-width: 100%;
//   margin: 0 auto;
// }

// .about-description h3 {
//   font-size: 18px;
//   font-weight: 600;
//   margin-bottom: 16px;
// }

// .about-description h4 {
//   font-size: 16px;
//   font-weight: 600;
//   margin-bottom: 8px;
//   margin-top: 20px;
// }

// .about-description p {
//   font-size: 15px;
//   line-height: 1.6;
//   color: #333;
//   margin-bottom: 20px;
// }

// .business-details-grid {
//   display: grid;
//   grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
//   gap: 20px;
//   margin: 30px 0;
//   background-color: #f9f9f9;
//   padding: 20px;
//   border-radius: 8px;
//   width:100%;
//   box-sizing: border-box;
// }

// .detail-item h4 {
//   margin-top: 0;
// }

// .detail-item p {
//   margin-bottom: 0;
// }

// .contact-info {
//   margin-top: 40px;
//   padding-top: 20px;
//   border-top: 1px solid #e1e3df;
// }

// .contact-info p {
//   margin-bottom: 10px;
// }

// .website-link {
//   color: #222;
//   text-decoration: underline;
//   font-weight: normal;
// }

// .website-link:hover {
//   color: #4CAF50;
// }

// /* Error Styles */
// .error-container {
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   min-height: 300px;
//   font-size: 18px;
// }

// /* Mobile Responsiveness */
// @media (max-width: 768px) {
//   .logo-container {
//     left: 50%;
//     transform: translateX(-50%);
//   }

//   .products-grid {
//     grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
//   }

//   .business-details-grid {
//     grid-template-columns: 1fr;
//   }
// }

// /* Verdure Verified Badge Styles */
// .verified-badge-container {
//   position: absolute;
//   right: 30px;
//   bottom: -40px;
// }

// .verified-badge-wrapper {
//   width: 120px;
//   height: 120px;
//   border-radius: 8px;
//   background-color: white;
//   box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
//   padding: 6px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }

// .verified-badge {
//   max-width: 100%;
//   max-height: 100%;
//   border-radius: 4px;
//   object-fit: contain;
// }

// /* Update mobile responsiveness for verified badge */
// @media (max-width: 768px) {
//   .verified-badge-container {
//     right: 50%;
//     transform: translateX(50%);
//     bottom: -140px; /* Position it below the logo on mobile */
//   }

//   /* Adjust shop intro margin to accommodate badge on mobile */
//   .shop-intro {
//     margin-top: 60px;
//   }
// }

// @media (max-width: 768px) {
//   /* Banner container needs more margin to accommodate the elements */
//   .shop-banner-container {
//     margin-bottom: 75px;
//   }

//   /* Position logo at the bottom left of banner */
//   .logo-container {
//     left: 20px;
//     transform: none;
//     bottom: -40px;
//     width: 100px;
//     height: 100px;
//   }

//   .logo-wrapper {
//     width: 100%;
//     height: 100%;
//   }

//   /* Position verified badge at the bottom right of banner */
//   .verified-badge-container {
//     right: 20px;
//     transform: none;
//     bottom: -40px;
//     width: 100px;
//     height: 100px;
//   }

//   .verified-badge-wrapper {
//     width: 100%;
//     height: 100%;
//   }

//   /* Allow space for badges before content starts */
//   .shop-intro {
//     padding-top: 60px;
//   }

//   /* Make banner shorter on mobile */
//   .banner-wrapper {
//     height: 200px;
//   }

//   /* Stack and center badges if screen is very narrow */
//   @media (max-width: 480px) {
//     .shop-banner-container {
//       margin-bottom: 190px;
//     }

//     .logo-container {
//       left: 50%;
//       transform: translateX(-75px);
//       bottom: -40px;
//     }

//     .verified-badge-container {
//       left: 50%;
//       transform: translateX(75px);
//       bottom: -40px;
//     }

//     .shop-intro {
//       padding-top: 70px;
//     }
//   }
// }

// /* Handle no banner case */
// .shop-banner-container.no-banner {
//   margin-bottom: 60px;
//   position: relative;
//   height: 100px; /* Minimum height to ensure logo and badge visibility */
//   background-color: #f9f9f9; /* Light background when no banner */
// }

// .banner-placeholder {
//   width: 100%;
//   height: 100px;
// }

// /* Make sure logo and badge show up even without banner */
// .no-banner .logo-container,
// .no-banner .verified-badge-container {
//   bottom: -40px;
// }

// /* Mobile adjustments for no-banner case */
// @media (max-width: 768px) {
//   .shop-banner-container.no-banner {
//     height: 80px;
//   }

//   .banner-placeholder {
//     height: 80px;
//   }

//   /* Apply the same positioning rules for mobile */
//   .no-banner .logo-container,
//   .no-banner .verified-badge-container {
//     bottom: -40px;
//   }

//   /* Stack and center badges if screen is very narrow */
//   @media (max-width: 480px) {
//     .shop-banner-container.no-banner {
//       margin-bottom: 190px;
//     }
//   }
// }

// .pagination-controls {
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   margin-top: 40px;
//   gap: 15px;
// }

// .pagination-button {
//   background-color: #ffffff;
//   border: 1px solid #e1e3df;
//   color: #222;
//   font-size: 14px;
//   font-weight: 500;
//   padding: 8px 16px;
//   border-radius: 24px;
//   cursor: pointer;
//   transition: all 0.2s ease;
//   min-width: 100px;
//   box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
// }

// .pagination-button:hover:not(:disabled) {
//   background-color: #f9f9f9;
//   border-color: #d3d3d3;
//   transform: translateY(-1px);
//   box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
// }

// .pagination-button:active:not(:disabled) {
//   transform: translateY(0);
//   box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
// }

// .pagination-button:disabled {
//   opacity: 0.5;
//   cursor: not-allowed;
//   background-color: #f5f5f5;
// }

// .pagination-info {
//   font-size: 14px;
//   color: #595959;
//   display: flex;
//   align-items: center;
//   min-width: 120px;
//   justify-content: center;
// }

// /* Page number buttons */
// .pagination-numbers {
//   display: flex;
//   gap: 8px;
//   align-items: center;
// }

// .page-number {
//   width: 36px;
//   height: 36px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   border-radius: 50%;
//   border: 1px solid #e1e3df;
//   background-color: #ffffff;
//   cursor: pointer;
//   font-size: 14px;
//   color: #222;
//   transition: all 0.2s ease;
// }

// .page-number.active {
//   background-color: #4CAF50;
//   color: white;
//   border-color: #4CAF50;
// }

// .page-number:hover:not(.active) {
//   background-color: #f9f9f9;
//   border-color: #d3d3d3;
// }

// /* Mobile responsiveness */
// @media (max-width: 768px) {
//   .pagination-controls {
//     flex-wrap: wrap;
//     gap: 10px;
//   }

//   .pagination-numbers {
//     order: 3;
//     width: 100%;
//     justify-content: center;
//     margin-top: 10px;
//   }

//   .pagination-button {
//     min-width: 80px;
//     padding: 6px 12px;
//   }
// }

// /* Verdure Verified Info Button Styles */
// .verified-badge-wrapper {
//   position: relative;
//   display: inline-block;
// }

// .info-button {
//   position: absolute;
//   top: -5px;
//   right: -5px;
//   width: 4px;
//   height: 40px;
//   border-radius: 50%;
//   background-color: #2C6E49;
//   color: white;
//   border: none;
//   font-size: 20px;
//   font-weight: bold;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
// }

// .verified-info-tooltip {
//   position: absolute;
//   top: calc(100% + 10px);
//   right: -10px;
//   width: 250px;
//   background-color: white;
//   padding: 12px;
//   border-radius: 8px;
//   box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
//   z-index: 100;
//   font-size: 14px;
//   line-height: 1.4;
// }

// .verified-info-tooltip:before {
//   content: '';
//   position: absolute;
//   top: -8px;
//   right: 15px;
//   width: 0;
//   height: 0;
//   border-left: 8px solid transparent;
//   border-right: 8px solid transparent;
//   border-bottom: 8px solid white;
// }

// @media screen and (max-width: 768px) {
//   .verified-info-tooltip {
//     width: 200px;
//     right: -50px;
//     font-size: 13px;
//   }

//   .verified-info-tooltip:before {
//     right: 55px;
//   }
// }

// /* For very small screens */
// @media screen and (max-width: 480px) {
//   .verified-info-tooltip {
//     width: 180px;
//     right: auto;
//     left: 50%;
//     transform: translateX(-50%);
//   }

//   .verified-info-tooltip:before {
//     right: auto;
//     left: 50%;
//     transform: translateX(-50%);
//   }
// }

import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { fetchBusinessById, API_URL } from "../services/api";
import "./BusinessDetail.css";
import verdureverified from "./verdureverified.png";
import shrok from "./shrok100.svg";

const BusinessDetail = () => {
  const { businessId } = useParams();
  const [products, setProducts] = useState([]);
  const [businessInfo, setBusinessInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [productLoading, setProductLoading] = useState(false);
  const [sustainabilityInfo, setSustainabilityInfo] = useState([]);
  const [sustainabilityLoading, setSustainabilityLoading] = useState(false);
  const [showVerifiedInfo, setShowVerifiedInfo] = useState(false);
  const [expandedItems, setExpandedItems] = useState({}); // New state for dropdown toggles

  // Refs for scroll functionality
  const productsRef = useRef(null);
  const aboutRef = useRef(null);
  const contactRef = useRef(null);
  const sustainabilityRef = useRef(null);

  useEffect(() => {
    // First fetch business details
    const fetchBusinessDetails = async () => {
      try {
        const businessData = await fetchBusinessById(businessId);
        setBusinessInfo(businessData);
        // Once business info is loaded, we can start loading products
        fetchProducts(1);
        // Also fetch sustainability info
        fetchSustainabilityInfo();
      } catch (err) {
        console.error("Error fetching business details:", err);
        setError("Failed to load business details.");
        setLoading(false);
      }
    };

    fetchBusinessDetails();
  }, [businessId]);

  // Function to fetch sustainability information
  const fetchSustainabilityInfo = async () => {
    setSustainabilityLoading(true);
    try {
      const response = await fetch(
        `${API_URL}api/verduresustainability/${businessId}/`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setSustainabilityInfo(data || []);
      setSustainabilityLoading(false);
    } catch (err) {
      console.error("Error fetching sustainability info:", err);
      // We don't set main error for this as it's not critical
      setSustainabilityInfo([]);
      setSustainabilityLoading(false);
    }
  };

  // Function to fetch products with pagination
  const fetchProducts = async (page) => {
    setProductLoading(true);
    try {
      // Direct fetch from API with pagination
      const response = await fetch(
        `${API_URL}api/products-by-business/${businessId}/?page=${page}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Update products state with the lightweight data
      setProducts(data.results || []);

      // Calculate total pages
      const count = data.count || 0;
      const pageSize = 10; // Match with backend page_size
      setTotalPages(Math.ceil(count / pageSize));

      setCurrentPage(page);
      setProductLoading(false);

      if (loading) {
        setLoading(false);
      }
    } catch (err) {
      console.error("Error fetching products:", err);
      setError("Failed to load products.");
      setProductLoading(false);

      if (loading) {
        setLoading(false);
      }
    }
  };

  // Change page handler
  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
      fetchProducts(newPage);

      // Scroll to top of products section when changing pages
      productsRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Toggle dropdown for sustainability items
  const toggleExpanded = (itemId) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemId]: !prev[itemId],
    }));
  };

  // Scroll functions for navigation
  const scrollToProducts = () => {
    productsRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToAbout = () => {
    aboutRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToSustainability = () => {
    sustainabilityRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const generatePaginationNumbers = () => {
    let pages = [];
    const maxPagesToShow = 5; // Maximum page numbers to display

    if (totalPages <= maxPagesToShow) {
      // Show all pages if total pages is less than or equal to maxPagesToShow
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always include first page
      pages.push(1);

      if (currentPage <= 3) {
        // If current page is near the beginning
        pages.push(2, 3, 4);
        pages.push("...");
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        // If current page is near the end
        pages.push("...");
        pages.push(totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        // If current page is in the middle
        pages.push("...");
        pages.push(currentPage - 1, currentPage, currentPage + 1);
        pages.push("...");
        pages.push(totalPages);
      }
    }

    return pages;
  };

  if (error) {
    return <div className="error-container">{error}</div>;
  }

  const hasSustainabilityInfo =
    sustainabilityInfo && sustainabilityInfo.length > 0;

  return (
    <div className="business-detail-container">
      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          <p
            style={{
              marginTop: "20px",
              color: "#4CAF50",
              fontWeight: "600",
              marginTop: "90%",
            }}
          >
            Shrok is fetching the goods! 🌱
          </p>
        </div>
      )}
      {/* Floating Shrok elements for ambiance */}
      <div className="floating-shroks">
        <img src={shrok} alt="" className="floating-shrok" />
        <img src={shrok} alt="" className="floating-shrok" />
        <img src={shrok} alt="" className="floating-shrok" />
        <img src={shrok} alt="" className="floating-shrok" />
        <img src={shrok} alt="" className="floating-shrok" />
        <img src={shrok} alt="" className="floating-shrok" />
      </div>
      {/* Loading Overlay */}
      {/* {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )} */}

      {/* Navigation bar */}
      <nav className="shop-navigation">
        <div className="shop-nav-container">
          {/* <div className="shop-name">{businessInfo?.name}</div> */}
          <div className="shop-nav-links">
            <button onClick={scrollToAbout} className="nav-link">
              About
            </button>
            {hasSustainabilityInfo && (
              <button onClick={scrollToSustainability} className="nav-link">
                Shrok's Notes
              </button>
            )}
            <button onClick={scrollToProducts} className="nav-link">
              Products
            </button>
            <button onClick={scrollToContact} className="nav-link">
              Contact
            </button>
          </div>
        </div>
      </nav>

      {/* Banner and Logo Section */}
      <div
        className={`shop-banner-container ${
          !businessInfo?.banner ? "no-banner" : ""
        }`}
      >
        {businessInfo?.banner ? (
          <div className="banner-wrapper">
            <img
              src={businessInfo.banner}
              alt={`${businessInfo.name} banner`}
              className="shop-banner"
            />
          </div>
        ) : (
          // Fallback placeholder div when there's no banner
          <div className="banner-placeholder"></div>
        )}

        {businessInfo?.logonew && (
          <div className="logo-container">
            <div className="logo-wrapper">
              <img
                src={businessInfo.logonew}
                alt={`${businessInfo.name} logo`}
                className="shop-logo"
              />
            </div>
          </div>
        )}

        {/* Verdure Verified Badge */}
        {businessInfo?.verdure_verified && (
          <div className="verified-badge-container">
            <div className="verified-badge-wrapper">
              <img
                src={verdureverified}
                alt="Verdure Verified"
                className="verified-badge"
              />
              <button
                className="info-button"
                onClick={() => setShowVerifiedInfo(!showVerifiedInfo)}
                aria-label="Show Verdure Verified information"
              >
                i
              </button>
              {showVerifiedInfo && (
                <div className="verified-info-tooltip">
                  <p>
                    Verdure Verified means our team checked through this
                    business and we did research on them, and the business also
                    sent additional information for us to help verify what they
                    provided. In many cases we also provide notes below.
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Shop Title */}
      <div className="shop-intro">
        <h1 className="shop-title">{businessInfo?.name}</h1>
      </div>

      {/* About and Sustainability Sections - Two Column Layout on Desktop */}
      <div className="about-sustainability-container">
        {/* About Business Section */}
        <div ref={aboutRef} className="about-section">
          <br></br>
          {/* <h2 className="section-title">About {businessInfo?.name}</h2> */}
          <div className="about-description">
            <h3>About</h3>
            <p>{businessInfo?.description}</p>
            <div className="business-details-grid">
              {/* Price Range - no dropdown */}
              <div className="detail-item no-dropdown">
                <div className="detail-header">
                  <h4>Price Range</h4>
                </div>
                <p>{businessInfo?.price_range}</p>
              </div>

              {/* Production - dropdown */}
              <div className="detail-item">
                <div
                  className="detail-header"
                  onClick={() => toggleExpanded("production")}
                >
                  <h4>Production</h4>
                  <span
                    className={`dropdown-arrow ${
                      expandedItems["production"] ? "expanded" : ""
                    }`}
                  >
                    ▼
                  </span>
                </div>
                {expandedItems["production"] && (
                  <div className="detail-content">
                    <p>{businessInfo?.production}</p>
                  </div>
                )}
              </div>

              {/* Shipping - dropdown */}
              <div className="detail-item">
                <div
                  className="detail-header"
                  onClick={() => toggleExpanded("shipping")}
                >
                  <h4>Shipping</h4>
                  <span
                    className={`dropdown-arrow ${
                      expandedItems["shipping"] ? "expanded" : ""
                    }`}
                  >
                    ▼
                  </span>
                </div>
                {expandedItems["shipping"] && (
                  <div className="detail-content">
                    <p>{businessInfo?.shipping_strategy}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Sustainability Section - Only shown if there's data */}
        {hasSustainabilityInfo && (
          <div ref={sustainabilityRef} className="sustainability-section">
            <div className="shrek-header">
              <img src={shrok} alt="Shrok" className="shrok-image" />
              <h2 className="section-title shrek-title">Shrok's Notes</h2>
            </div>
            <div className="sustainability-content">
              {sustainabilityLoading ? (
                <div className="sustainability-loading">
                  <div className="spinner sustainability-spinner"></div>
                </div>
              ) : (
                <div className="sustainability-items">
                  {sustainabilityInfo.map((item) => (
                    <div key={item.id} className="sustainability-item">
                      <div
                        className="sustainability-header"
                        onClick={() => toggleExpanded(item.id)}
                      >
                        <h3>{item.title}</h3>
                        <span
                          className={`dropdown-arrow ${
                            expandedItems[item.id] ? "expanded" : ""
                          }`}
                        >
                          ▼
                        </span>
                      </div>
                      {expandedItems[item.id] && (
                        <div className="sustainability-explanation">
                          <p>{item.explanation}</p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Products Section */}
      <div ref={productsRef} className="products-section">
        {/* <h2 className="section-title">Products by {businessInfo?.name}</h2> */}
        <h2 className="section-title products-title">
          Products by {businessInfo?.name}
        </h2>

        {productLoading ? (
          <div className="product-loading">
            <div className="spinner product-spinner"></div>
          </div>
        ) : products.length > 0 ? (
          <>
            <div className="products-grid">
              {products.map((product) => (
                <div key={product.id} className="product-card">
                  <a
                    href={`/shop/products/${product.id}`}
                    className="product-link"
                  >
                    <div className="product-image-container">
                      <img
                        src={product.primary_image || "/placeholder.jpg"}
                        alt={product.name}
                        className="product-image"
                      />
                    </div>
                    <div className="product-info">
                      <h3 className="product-name">{product.name}</h3>
                      <p className="related-product-price">
                        ${Number(product.price || 0).toFixed(2)}
                      </p>
                    </div>
                  </a>
                </div>
              ))}
            </div>

            {totalPages > 1 && (
              <div className="pagination-controls">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="pagination-button"
                >
                  Previous
                </button>

                <div className="pagination-numbers">
                  {/* Generate page number buttons */}
                  {generatePaginationNumbers().map((pageNum) =>
                    pageNum === "..." ? (
                      <span
                        key={`ellipsis-${Math.random()}`}
                        className="pagination-ellipsis"
                      >
                        ...
                      </span>
                    ) : (
                      <button
                        key={pageNum}
                        onClick={() => handlePageChange(pageNum)}
                        className={`page-number ${
                          currentPage === pageNum ? "active" : ""
                        }`}
                      >
                        {pageNum}
                      </button>
                    )
                  )}
                </div>

                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="pagination-button"
                >
                  Next
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="no-products-message">
            No products available from this business at the moment.
          </div>
        )}
      </div>

      {/* Contact Section */}
      <div ref={contactRef} className="contact-section">
        {/* <h2 className="section-title">Contact {businessInfo?.name}</h2> */}
        <br></br>
        <div className="contact-info">
          {/* <br></br> */}
          <h2 className="section-title contact-title">
            Contact {businessInfo?.name}
          </h2>
          <p>
            <strong>Email:</strong> {businessInfo?.email}
          </p>
          {businessInfo?.website && (
            <p>
              <strong>Website:</strong>{" "}
              <a
                href={businessInfo.website}
                className="website-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {businessInfo.website}
              </a>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default BusinessDetail;
